module.exports = "/assets/1879aed422f805d92c72aac44e0f8a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2A.png
// module id = 976
// module chunks = 0